import { dynamicGa4DataLayerPush } from '@which/shared';
export const pushDataLayerClick = _ref => {
  let {
    toolInfo: {
      name,
      category
    },
    itemText
  } = _ref;
  dynamicGa4DataLayerPush({
    eventName: 'click_tool',
    item_group: category,
    tool_name: name,
    item_text: itemText,
    event: 'static_tool_click'
  });
};